import api from "../../client";

export const deleteTagRequest = async (id: string): Promise<void> => {
  const { data } = await api.delete(`/tag/${id}`);

  return data;
};
